import React, { useRef, useEffect, useCallback, useState} from 'react';
import {isMobile} from 'react-device-detect';
import {
    setSelectedPianoRollSteps,
    mouseDown
} from 'actions/index.js';
import Resolution from 'engine/Resolution.js';
import {toggleStep} from 'operations/actions.js';
import {connect} from 'react-redux';

const BASE_RESOLUTION = new Resolution(32, false);

const DOUBLE_CLICK_TIME = 250;

const StepToggle = ({
    track,
    color,
    on,
    stepNumber,
    resolution,
    stepData,
    trackStep,
    isCurrentStep,
    selectedPianoRollSteps=[],
    setSelectedSteps,
    cirklonMode,
    mouseDown
}) => { 
    const lastClick = useRef(0);

    const isSelected = selectedPianoRollSteps &&
          selectedPianoRollSteps.indexOf(stepData) > -1;

    const onMouseOver = useCallback(() => {
        if (isMobile) {
            return;
        }
        let isMouseDown = track.sequencerEngine.state.keyboard.isMouseDown;
        if (isMouseDown) {
            if (cirklonMode && on) {
                selectStep(stepData);
            } else if (!cirklonMode) {
                toggle();
            }
        }
    }, [
        isSelected,
        track,
        cirklonMode,
        on,
        resolution,
        stepNumber,
        selectedPianoRollSteps]);

    const onClick = useCallback((isTouch) => {
        if (!isTouch && isMobile) {
            return;
        }
        mouseDown(true);
        // todo: check if in gang/slope mode, if so then select the
        // steps instead of togglin
        if (cirklonMode && on) {
            selectStep(stepData);
        } else {
            toggle();
        }
    }, [
        stepNumber,
        stepData,
        track,
        cirklonMode,
        selectedPianoRollSteps,
        isSelected,
        on,
        resolution]); 

    const toggle = useCallback(() => {
        track.pattern.clearCache();
        track.sequencerEngine.operationManager.dispatch(
            toggleStep(track, stepNumber, resolution));
    }, [track, stepNumber, resolution]);

    const selectStep = useCallback((step) => {
        if (isSelected) {
            // unselect cuz its already selected
            let i = selectedPianoRollSteps.indexOf(stepData);
            selectedPianoRollSteps.splice(i, 1);
            setSelectedSteps([... selectedPianoRollSteps]);
        } else {
            setSelectedSteps([... selectedPianoRollSteps, stepData]);
        }
    }, [isSelected, selectedPianoRollSteps, setSelectedSteps, stepData]);

    let className = "step-toggle";
    let style = {};
    
    if (on) {
        className += " on";
        style.backgroundColor = color;
    }

    if (isCurrentStep) {
        className += " current";
    }

    if (isSelected) {
        className += " selected";
    }
    return (
        <div
          data-stepNumber={stepNumber}
          style={style}
          onMouseOver={onMouseOver}
          onMouseDown={(e) => {
              e.stopPropagation();
              onClick(false);
          }}
          onTouchStart={() => onClick(true)}
          className={className}>
            {stepNumber + 1}
          </div>);
}

const mapStateToProps = (state, props) => {
    let resolution = state.sequencer.displayResolution;
    let trackStep = props.track.sequencerEngine.trackStep;
    let patternStep = Math.floor(resolution.transformStepAtResolution2(
        props.track.getPatternStep(trackStep),
        BASE_RESOLUTION));
    return {
        resolution,
        isCurrentStep: patternStep === props.stepNumber,
        selectedPianoRollSteps: state.keyboard.selectedPianoRollSteps,
        cirklonMode: state.cirklon.cirklonMode[props.track.id],
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
        setSelectedSteps: (steps) =>
            dispatch(setSelectedPianoRollSteps(steps)),
        mouseDown: (m) =>
            dispatch(mouseDown(m)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StepToggle);
